
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.076 5.479a.376.376 0 110 .75h-.715l-.84 5.096c-.093.568-.304 1-.633 1.3-.329.302-.75.453-1.266.453-.103 0-.198-.005-.283-.015-.158-.017-.245-.18-.206-.332l.072-.275c.033-.13.18-.211.314-.203.113.01.191.015.236.015.198 0 .379-.083.54-.25.163-.167.267-.398.313-.693l.84-5.095h-.466a.376.376 0 010-.751h.598l.089-.56c.095-.596.319-1.052.67-1.366a1.768 1.768 0 011.214-.475c.14 0 .292.014.457.04.214.032.31.256.222.453l-.124.279a.213.213 0 01-.235.115 1.287 1.287 0 00-.232-.018c-.294 0-.532.081-.714.243-.179.162-.294.405-.346.73l-.088.559h.583z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.49 6.75a.406.406 0 10-.741.329l.783 1.67-1.346 1.68a.36.36 0 10.565.448L9.94 9.36l.636 1.414a.406.406 0 10.736-.342l-.798-1.667 1.366-1.683a.357.357 0 10-.562-.44l-1.201 1.6-.628-1.494z","fill":"currentColor","stroke":"currentColor","stroke-width":".115"}})])
          )
        }
      }
    